module.exports = __webpack_public_path__ + "static/assets/b0e76d4308c519856f176b614b1a7880.svg";